import React, { useEffect, useState } from "react";
import Select from 'react-select'
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import { FilterProps } from "../../../types/layout";
import { 
    Box, 
    Flex, 
    Tag,
    TagLabel,
    TagCloseButton,
    Text,
    Tooltip 
} from "@chakra-ui/react";
import CustomButton from "../buttons/Button";
import { BsArrowDownLeft, BsCalendar, BsInfo, BsPlus, BsX } from "react-icons/bs";
import CustomTag from "../tag";
import CustomTabs from "../tabs/Tabs";
import CustomModal from "../modals";
import CustomDatePicker from "../date";
import { transformString } from "../../../utilities/others";
import { fieldClauseMatch } from "../../../utilities/dummy";
import FilterItem from "./Filter";
import CustomSearch from "../search";
import CustomSort from "../sort";

export default function CustomPageFilters({
    userId,
    pageType,
    isFilter,
    fields,
    currentFilters,
    onSetCurrentFilters,
    isOpen,
    onOpen,
    ...props
}: FilterProps) {
    const [property, setProperty] = useState('');
    const [filterVal, setFilterVal] = useState(currentFilters);
    const [searchValue, setSearchValue] = useState('')
    const [isDateVisible, setIsDateVisible] = useState(false);
    const [filterDate, setFilterDate] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });
    const [finalFieldObj, setFinalFieldObj] = useState<any>({})
    const [tagObj, setTagObj] = useState({} as Record<string, boolean>)
    const [fieldClause, setFieldClause] = useState({} as Record<string, string[]>)
    
    // transform the following arrays because the select library being used accepts only array of objects instead of array of strings
    const filterFields = fields && Object.keys(fields) && Object.keys(fields).map((field) => ({ label: transformString(field), value: field } ));
    const fieldClausesOptions = !!fieldClause && fieldClause[property] && fieldClause[property].map((field) => ({ label: field, value: field } ));

    function handleSearch(val: string) {        
        if (props?.searchObj!?.type === 'page') {
            props.onSetCurrentPage && props.onSetCurrentPage(`${pageType}Page`, 1);
        }
        setSearchValue(val);
        props.onSearch && props.onSearch(val.toLowerCase())
    }

    function onCloseModal() {
        setProperty('');
        props.onClose && props.onClose()
    }

    function handleOpenDateView() {
        setIsDateVisible(true)
    }

    function computeFilterValue(value: any) {  
        console.log({ value, filterVal });
              
        if (!filterVal) return;
        
        console.log({ value, filterVal, filterMode: props.filterMode, property });

        if (props.filterMode === 'multiple') {
            const currentValue = filterVal[property] || [];
            
            const newValue = uniq([...currentValue, value]);
            console.log({ currentValue, newValue });
            
            const filters = {...filterVal, [property]: newValue}
            setFilterVal(filters);
        } else {
            const newValue = [value];            
			const filters = { ...filterVal, [property]: newValue };
            
            console.log({ filters, newValue });        
			setFilterVal(filters); 
        }
    }

    function setFieldPropertyClause() {
        const getClauseValue = fieldClauseMatch[property] || [];
        setFieldClause((prevValue) => ({
            ...prevValue,
            [property]: getClauseValue
        }))
    }

    function setFinalField(val: string) {
        const newValue = [val]
        setFinalFieldObj((prevValue: any) => ({
            ...prevValue,
            [property]: {...prevValue[property], newValue}
        }))
    }

    // function handleRemoveFilterValue(value: any) {
    //     if (!filterVal) return;

    //     const currValue = filterVal[property] || [];
	// 	const newValue = currValue.filter((el) => el !== value);
	// 	const filters = { ...filterVal, [property]: newValue };
	// 	setFilterVal(filters);
    // }

    // function handleClearMultipleFilters(value: any) {
    //     const filters = { ...filterVal, [property]: value };
	// 	if (!filters[property].length) {
	// 		setFilterVal(filters);
	// 	}
    // }

    function computeTimeFilter (value?: any, values?: any) {
        const fromValue = value[0] ? [value[0].format('YYYY-MM-DD')] : [];
		const toValue = value[1] ? [value[1].format('YYYY-MM-DD')] : [];
		if (values === 'time') {
			const timeFilter = {
				...filterVal,
				from: fromValue,
				to: toValue,
			};
			setFilterVal(timeFilter);
		} else if (values === 'dob') {
			const timeFilter = {
				...filterVal,
				'start-date-of-birth': fromValue,
				'end-date-of-birth': toValue,
			};
			setFilterVal(timeFilter);
		}
    }

    function setInputFilterValue(e: React.ChangeEvent<HTMLInputElement>) {
        const newValue = [e.target.value];
        const filters = { ...filterVal, [property]: newValue }
        setFilterVal(filters)
    }

    function onDateFilterChange(key: string, value: any) {
        setFilterDate((prevState) => ({
            ...prevState,
            [key]: value 
        }));  
    }

    function filterByTime() { 
        const from = filterDate.startDate?.toLocaleDateString();      
        const to = filterDate.endDate?.toLocaleDateString();

        const timeFilter = {
            ...filterVal,
            from: [from],
            to: [to]
        };
        setFilterVal(timeFilter)
  
        setIsDateVisible(false);
    }

    function handleTagSet(val: boolean) {        
        setTagObj((prevState) => ({
            ...prevState,
            [property]: val
        }))
    }

    function computeTagNames(
        key: string, 
        id: string | { id?: string; label?: string; name?: string; value?: string;}[]
    ) {
        console.log({ key, id, fields, 'tagObj[key]': tagObj[key] });
        
        if (fields) {
            if (key === 'from' || key === 'to') {
                return id;
            }

            if (fields[key]) {
                if (typeof id === 'string') {
                    return id;
                }

                if (!tagObj[key] && Array.isArray(id)) {
                    const join = [...id];
                    console.log({ join });
                    
                    return join.map(item => item?.id).join(", ")
                }
            }

            let selectedField = [];
            let name: string | undefined;
            const arr = fields[key];

            if (Array.isArray(arr)) {
                selectedField = arr.filter(el => el.id === id);
                name = selectedField?.[0]?.name
                || selectedField?.[0]?.value 
                || selectedField?.[0]?.displayName 
                || selectedField?.[0]?.id 
            }
            return name;
        }
        // return id;
    }

    function handleTagRemoval(key: string, value: string) {
        if (!filterVal) return;

        const newFilterVal = filterVal[key].filter((el) => el !== value);
        const filter = {...filterVal, [key]: newFilterVal };
        setFilterVal(filter)
        onSetCurrentFilters && onSetCurrentFilters(`${pageType}Filters`, filter);
    }

    function handleClearAllFilters() {
        setFilterVal({});
		onSetCurrentFilters && onSetCurrentFilters(`${pageType}Filters`, {});
    }

    console.log({ finalFieldObj });
    
    useEffect(() => {
        setFieldPropertyClause()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [property])

    return (
        <>
        <Box className="wrap">
            <Flex className="filter__header--wrap" direction={'row'} align='center' justify='flex-end'>
                <Box>
                    <>
                        {props.goBackAction && (
                            <CustomButton cta='text' onClick={props.goBackAction} isLeftIcon leftIcon={<BsArrowDownLeft />} />
                        )}

                        {props.tags && props.tags.map((tag) => (
                            !!tag && <CustomTag size='sm' status={tag} key={tag} />
                        ))}
                    </>
                    
                    {props.children}
                    
                    {props.tabs && !!props.tabs.length && (
                        <CustomTabs 
                            variant='line' 
                            size="sm" 
                            tabs={props.tabs} 
                        />
                    )}
                </Box>
                
                {props.isNewButton && (
                    <Flex direction={'row'} align='center' justify='flex-end'>
                        <CustomButton
                            className="mr--10"
                            onClick={props.addNewObj?.onClick}
                            isLeftIcon
                            leftIcon={<BsPlus />}
                            label={`New ${props.addNewObj?.pageType}`}
                            variant='solid'
                            cta={'primary'}
                            size={'sm'}
                        />
                    </Flex>
                )}
                
                {/* Search */}
                {props.isSearch && (
                    <CustomSearch 
                        placeholder={props.searchPlaceholder!} 
                        searchValue={searchValue!} 
                        onChange={handleSearch}
                    />
                )}

                 {/* Search */}
                 {props.isSort && props.sortObj?.sortFn && (
                    <CustomSort 
                       sortValue={props.sortObj?.sortValue!} 
                        onSort={props.sortObj?.sortFn!} 
                    />
                )}

                {/* Date filter */}
                {props.isDate && (
                    <CustomButton
                        className="mr--10 button__gray"
                        onClick={handleOpenDateView}
                        isLeftIcon
                        leftIcon={<BsCalendar />}
                        label="Date"
                        variant='outline'
                        cta={'outline'}
                        size={'sm'}
                    />
                )}

                {props.buttons && props.buttons.map((button, index) => (
                    <Box key={index}>
                        <CustomButton 
                            key={button.label}
                            className="button__gray"
                            onClick={
                                button.label === 'Filter' ? () => onOpen!() : button.onClick}
                            label={button.label}
                            isLeftIcon
                            leftIcon={button.icon}
                            disabled={button.disabled}
                            cta={'outline'}
                            size={'sm'}
                        />
                        {button.tooltip && (
                            <Tooltip title={button.tooltip} placement={'left-start'}>
                                <span className='jjjjj'>
                                    <BsInfo />
                                </span>
                            </Tooltip>
                        )}
                    </Box>
                ))}
            </Flex>

            {/* Filtered tags */}
            {!!filterVal && isFilter && (
                <Flex mt={'8'} alignItems={'center'} pl={'1'}>
                    {map(filterVal!, (value, key) => (
                        value.map((val) => (
                            <Tag 
                                key={val} 
                                borderRadius='full'
                                variant='outline'
                                colorScheme='twitter'
                                size='md'
                                fontSize={'sm'}
                                mr={'2'}
                            >
                                <TagLabel>									
                                    {key === 'tagIds' ? `tag is ${computeTagNames(key, val)}` : `${key}: ${computeTagNames(key, val)}`}
                                </TagLabel>
                                <TagCloseButton onClick={() => handleTagRemoval(key, val)} />
                            </Tag>
                        ))
                    ))}

                    {!!Object.keys(filterVal!).length && (
                        <CustomButton
                            onClick={handleClearAllFilters}
                            key="clearAll"
                            label="Clear All"
                            isLeftIcon
                            size="xs"
                            colorScheme="red"
                            variant={'outline'}
                            cta={'outline'}
                            leftIcon={<BsX />}
                        />
                    )}
                </Flex>
            )}
        </Box>

            {/* modals here */}
            {/* Date filter modal */}
            <CustomModal
                isOpen={isDateVisible}
                onCloseFn={() => setIsDateVisible(false)}
                isFooter={false}
                size={'sm'}
                headerTitle={'Select a date range'}
            >
                <Flex className="w--100" direction={'row'} align='center' justifyContent={'center'} mb={'4'}>
                        <Box className="w--50 mr--5">
                            <Text fontSize='sm'>From</Text>
                            <CustomDatePicker
                                onChange={(date) => onDateFilterChange('startDate', date)}
                                startDate={filterDate.startDate}
                                date={filterDate.startDate}
                                endDate={filterDate.endDate}
                                selectsStart
                                placeholder="Select start date..."
                            />
                        </Box>
                        <Box className="w--50">
                            <Text fontSize='sm'>To</Text>
                            <CustomDatePicker
                                onChange={(date) => onDateFilterChange('endDate', date)}
                                selectsEnd
                                startDate={filterDate.startDate}
                                endDate={filterDate.endDate}
                                date={filterDate.endDate}
                                placeholder="Select end date..."
                            />
                        </Box>
                </Flex>
                <Flex justifyContent={'flex-end'}>
                        <CustomButton size="sm" label="Filter" cta={'primary'} variant={'solid'} onClick={filterByTime} />
                </Flex>
            </CustomModal>

            {/* Filter view modal */}
            <CustomModal isOpen={isOpen} onCloseFn={onCloseModal} isFooter={false} size={'3xl'}>
                <Flex alignItems={'center'} justifyContent={'stretch'}>
                    <Select 
                        isClearable
                        className="react-select-filter text--sm mr--10 flex-1"
                        isSearchable
                        backspaceRemovesValue
                        captureMenuScroll
                        closeMenuOnSelect
                        onChange={(value) => setProperty(value?.value!)}
                        getOptionLabel={(option) => option.value === 'tagIds' ? 'Tags': option.label}
                        options={filterFields!}
                    />

                    {/* Clause tag */}
                    {fieldClausesOptions && (
                        <Select 
                            isClearable
                            className="react-select-filter text--sm mr--10 flex-1"
                            isSearchable
                            backspaceRemovesValue
                            captureMenuScroll
                            closeMenuOnSelect
                            onChange={(value) => setFinalField(value?.value!)}
                            getOptionLabel={(option) => option.label}
                            options={fieldClausesOptions}
                        />
                    )}

                    {/* Field values */}
                    {!!fields && fields[property] && (
                        <FilterItem 
                            field={fields[property]} 
                            computeTimeFilter={computeTimeFilter} 
                            setTagKey={handleTagSet}
                            computeFilterValue={computeFilterValue}
                            setInputFilterValue={setInputFilterValue}
                        />
                    )}

                    <Box className="flex-1" maxW={'60px'}>
                        <CustomButton 
                            // onClick={}
                            label='Filter'
                            // disabled={button.disabled}
                            cta={'primary'}
                            size={'sm'}
                        />
                    </Box>
                </Flex>
            </CustomModal>
        </>
    )
}